import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppService } from './common/auth/app.service';
import { IdleService } from './common/auth/idle.service';
import { DestroyComponent } from './common/destroy-component/destroy-component';
import { User } from '@sentry/angular';
import { ErrorModalComponent } from './common/auth/error-modal/error.modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent extends DestroyComponent {
  idleState = '';
  profile: User;

  @ViewChild('childModal', { static: false }) childModal: ModalDirective;

  constructor(private idleService: IdleService, private appService: AppService, private dialog: MatDialog) {
    super();

    this.idleService.getIdleState().subscribe(state => {
      this.idleState = state;
      console.log(state);
      if (state === 'Timed out!') {
        this.childModal.hide();
      } else if (state.startsWith('(') || state === 'You\'ve gone idle!') {
        this.childModal.show();
      }
    });

    this.idleService.getTimedOut().subscribe(timedOut => {
      if (timedOut) {
        this.dialog.open(ErrorModalComponent, {
          data: { errorMessage: 'Your session has expired. Please log in again.' }
        });
        this.logout();
      }
    });

    this.appService.getUserLoggedIn().subscribe(userLoggedIn => {
      if (userLoggedIn) {
        this.idleService.startWatching();
      } else {
        this.idleService.stopWatching();
      }
    });
  }

  hideChildModal(): void {
    this.childModal.hide();
  }

  stay(): void {
    this.idleService.stay();
    this.hideChildModal();
  }

  logout(): void {
    this.idleService.logout();
  }
}
